import { FeaturedPartners } from '@/components/FeaturedPartners/FeaturedPartners';
import { FeaturedPartnersMetadataInterface } from '@/types/homepage.types';

export const RenderFeaturedPartners = ({ partners, title }: FeaturedPartnersMetadataInterface) => {
  return <FeaturedPartners title={title} data={partners} />;
};
